module.exports = __webpack_public_path__ + "img/step1.e9382a2e.jpg";